import React from 'react';
import { motion } from 'framer-motion';

const systems = [
  {
    title: 'Multi-tenant SaaS Platforms',
    description: 'Designed tenant-aware backend architectures with isolated data flows, role-based permissions, and scalable onboarding pipelines.',
    tags: ['Laravel', 'Redis', 'MySQL', 'Queues'],
  },
  {
    title: 'Construction Workforce Management System',
    description: 'Built workforce planning, assignment tracking, attendance workflows, and real-time operational dashboards.',
    tags: ['Laravel', 'Vue.js', 'MySQL', 'APIs'],
  },
  {
    title: 'Podcast Hosting SaaS Platform',
    description: 'Engineered media upload, processing, and publishing workflows with scalable storage and background jobs.',
    tags: ['Laravel', 'AWS S3', 'Redis', 'Workers'],
  },
  {
    title: 'School Management System',
    description: 'Developed student lifecycle modules including admissions, scheduling, staff roles, and administrative reporting.',
    tags: ['WordPress', 'PHP', 'MySQL', 'RBAC'],
  },
  {
    title: 'Subscription Commerce Platform',
    description: 'Implemented recurring billing workflows, subscription lifecycle handling, and payment gateway integrations.',
    tags: ['PHP', 'CodeIgniter', 'MySQL', 'Stripe'],
  },
  {
    title: 'Custom CMS Platforms',
    description: 'Delivered tailored CMS solutions for content-heavy organizations requiring flexible publishing and editorial workflows.',
    tags: ['WordPress', 'Custom PHP', 'REST APIs', 'Caching'],
  },
  {
    title: 'API Driven Platforms',
    description: 'Built API-first backends for web and mobile products with secure authentication and performance-focused endpoints.',
    tags: ['Laravel', 'REST API', 'JWT', 'Redis'],
  },
];

const SystemsBuiltV2 = () => {
  return (
    <section className="py-16 md:py-20 lg:py-24 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="w-full rounded-2xl bg-gray-50 border border-gray-200 p-6 md:p-8">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-6 tracking-tight text-gray-900">
          Systems I&apos;ve Built
        </h2>
        <div className="w-16 h-1 bg-blue-600 rounded mt-2 mb-6"></div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {systems.map((system, i) => (
            <motion.div
              key={system.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.45, delay: i * 0.08 }}
              viewport={{ once: true }}
              whileHover={{ y: -8 }}
              className="bg-white rounded-xl p-6 md:p-8 shadow-md hover:shadow-lg hover:-translate-y-1 transition-all duration-300 space-y-3"
            >
              <h3 className="text-lg md:text-xl font-semibold text-gray-900">{system.title}</h3>
              <p className="max-w-prose text-sm md:text-base text-gray-600 leading-relaxed mt-3 mb-4">{system.description}</p>
              <div className="flex flex-wrap gap-2">
                {system.tags.map((tag) => (
                  <span
                    key={tag}
                    className="px-3 py-1 rounded-full text-xs font-semibold bg-blue-100 text-blue-800"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
      </div>
    </section>
  );
};

export default SystemsBuiltV2;
